"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.operation_verify = void 0;
const _ = __importStar(require("lodash"));
const common_1 = require("@finley-technologies/common");
const tape_builder_base_1 = require("../../../types/tape-builder-base");
const commonOperationNode_1 = require("../../commonOperationNode");
const utils_1 = require("../../utils");
const types_1 = require("./types");
const commonProps = (0, commonOperationNode_1.commonZodOperationNodeUtils)(types_1.nodeType, types_1.UIConfigSchema, 'Verify');
// create a new UI node of this type.
const createNewNode = ({ id, nodeToCopy }) => {
    const nodeData = {
        metadata: {
            tapeBuilderNodeId: id,
            tapeBuilderNodeType: types_1.nodeType,
        },
        configuration: {
            description: 'description goes here',
            borrowerNumbersArtifactSlug: (0, tape_builder_base_1.asArtifactSlugRef)('borrowerNumbersSlug'),
            borrowerEligibilityResultsArtifactSlugs: {
                loanProductSlug1: (0, tape_builder_base_1.asArtifactSlugRef)('borrowerEligibilityResultsArtifactSlugForLp1'),
            },
        },
    };
    if (nodeToCopy) {
        (0, common_1.finleyAssert)(commonProps.isNode(nodeToCopy), `node must be a ${types_1.nodeType} node`);
        nodeData.configuration = _.cloneDeep(nodeToCopy.configuration);
        nodeData.configuration.borrowerNumbersArtifactSlug = (0, tape_builder_base_1.asArtifactSlugRef)('PLACEHOLDER');
        Object.keys(nodeData.configuration.borrowerEligibilityResultsArtifactSlugs).forEach((key) => {
            nodeData.configuration.borrowerEligibilityResultsArtifactSlugs[key] = (0, tape_builder_base_1.asArtifactSlugRef)('PLACEHOLDER');
        });
    }
    return nodeData;
};
/*
 * validate the configuration for the node. This checks shape as well
 * logical correctness.
 * This function should validate the config wrt rest of the graph as well.
 * if there is an error it should return an array of error messages.
 * if there are no errors it should return an empty array.
 */
const hasValidConfig = ({ graph, node, getUINode, }) => {
    (0, common_1.finleyAssert)(commonProps.isNode(node), `node must be a ${types_1.nodeType} node`);
    const allowedInputNodes = [
        'file_intermediateTape',
        'file_generatedBorrowingBaseReport',
    ];
    const errors = (0, utils_1.checkEdges)({
        node,
        graph,
        isAllowedInputNode: (uiNode) => allowedInputNodes.includes(uiNode.nodeType),
        getUINode,
        minInputs: 3,
        maxInputs: 100, // there could be many loan products, each of which will have its own borrower receivable eligibility results artifact node
        minOutputs: 1,
        maxOutputs: 1,
    });
    const borrowerEligibilityResultsArtifactSlugStrings = _.map(node.configuration.borrowerEligibilityResultsArtifactSlugs, (borrowerEligibilityResultsArtifactSlugForLoanProduct) => borrowerEligibilityResultsArtifactSlugForLoanProduct);
    const borrowerEligibilityResultsLoanProductSlugs = _.map(node.configuration.borrowerEligibilityResultsArtifactSlugs, (_artifactSlug, loanProductSlug) => loanProductSlug);
    const allInputDependencyNodesForNode = (0, utils_1.getAllInputDependencyNodesForNode)(node, graph);
    // @makarandp0 todo: Add type safety
    const loanProductSlugsInGraph = allInputDependencyNodesForNode
        .map((graphNode) => graphNode?.configuration?.loanProductSlug || null)
        .filter((slug) => slug !== null)
        .map((slug) => slug);
    const uniqueLoanProductSlugsInGraph = _.uniq(loanProductSlugsInGraph);
    const inputSlugs = [
        node.configuration.borrowerNumbersArtifactSlug,
        ...borrowerEligibilityResultsArtifactSlugStrings,
    ];
    const friendlyName = commonProps.getFriendlyName(node);
    const inputNodes = (0, utils_1.getSourceNodes)({ node, graph });
    inputNodes.forEach((inputNode) => {
        const inputUINode = getUINode(inputNode);
        const inputFriendlyName = commonProps.getFriendlyName(inputNode);
        if (inputUINode.isOperation || inputUINode.isRaw || inputUINode.isFinal) {
            errors.push(`${friendlyName} cannot use ${inputFriendlyName} as input`);
            return;
        }
        const inputNodeArtifactSlug = inputUINode.getArtifactSlug(inputNode);
        if (!inputSlugs.includes(inputNodeArtifactSlug)) {
            // it must be borrowing base
            if (inputUINode.nodeType !== 'file_generatedBorrowingBaseReport') {
                errors.push(`${friendlyName} input ${inputNodeArtifactSlug} is not listed in borrowerNumbersArtifactSlug or borrowerEligibilityResultsArtifactSlugs and is not borrowingBaseReport`);
            }
        }
    });
    uniqueLoanProductSlugsInGraph.forEach((loanProductSlugInGraph) => {
        if (!borrowerEligibilityResultsLoanProductSlugs.includes(loanProductSlugInGraph)) {
            errors.push(`${friendlyName} node input borrowerEligibilityResultsArtifactSlugs is missing entry for [loanProductSlug: ${loanProductSlugInGraph}]`);
        }
    });
    borrowerEligibilityResultsLoanProductSlugs.forEach((borrowerEligibilityResultsLoanProductSlug) => {
        if (!uniqueLoanProductSlugsInGraph.includes(borrowerEligibilityResultsLoanProductSlug)) {
            errors.push(`${friendlyName} node input borrowerEligibilityResultsArtifactSlugs has a loan product slug that does not exist on the graph [loanProductSlug: ${borrowerEligibilityResultsLoanProductSlug}]`);
        }
    });
    return errors;
};
/**
 * Represents an operation node
 */
exports.operation_verify = {
    ...commonProps,
    nodeType: types_1.nodeType,
    operationType: 'bbpl',
    createNewNode,
    hasValidConfig,
};
//# sourceMappingURL=uinode.js.map